import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'leads-receptions-dashboard-broker-performance',
  storeModule.createStoreModule('leads-receptions-dashboard-broker-performance', {
    fetchListURL: 'leads-receptions/dashboard/broker-performance'
  })
)
